import { render } from "./Arremate.vue?vue&type=template&id=166f2497&scoped=true"
import script from "./Arremate.vue?vue&type=script&lang=js"
export * from "./Arremate.vue?vue&type=script&lang=js"

import "./Arremate.vue?vue&type=style&index=0&id=166f2497&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166f2497"]])

export default __exports__